import { IResourceComponentsProps, useForm } from "@refinedev/core";
import { AntdEditInferencer } from "@refinedev/inferencer/antd";
import Cw8EditWrapper from "components/cw8/Cw8EditWrapper";
import { ChildForm, RenderItem } from "interfaces/schemaDB";
import { config } from "config";
import { useSchemaDB } from "hooks/useSchemaDB";
import EditInfografia from "./editInfografia";
// import InfografiaEdit from "./editInfografias";
// import { RenderItem } from 'src/interfaces/schemaDB';

export const InfografiasEdit: React.FC<IResourceComponentsProps> = () => {

  
  const resourceLabel :string = 'General';
  const resourceName :string = 'infografia';
  const { id } = useForm();

  // const {getProperty } = useSchemaDB({nameTable:"seccionInfografia"})
  
  const renderItem = (item: any, index: number  ) => {
    return(
      <p>## {index}
      {item["sec_nombre"]}
      </p>
    )

  }


  const childrenForms : ChildForm[] =[    
  {
    resourceName :"seccionInfografia",
    title : "Secciones",
    field : "sec_id_infografia",
    showCards : true,
    configCard :{
      fieldTitle : "sec_nombre",
      fieldDesc : "sec_descripcion",
      fieldImg : "",
      numColums : 4,
      // renderItem: renderItem 
    }
  },
  {
    resourceName :"recursoInfografia",
    title : "Recurso",
    field : "rec_id_infografia",
    createModal : true,
    editModal : true,       
    showCards : false,

  },
    {
    resourceName :"contentRelInfo",
    title : "Contenido Relacionado",
    field : "icr_id_infografia",
    createModal : true,
    editModal : true,       
    showCards : false,

  }
  // ,
  // {
  //   resourceName :"",
  //   title : "Slide",
  //   field : "sld_infografia"
  // },

  // {
  //   resourceName :"autorPublication",
  //   title : "Generar Json",
  //   field : "rec_id_infografia",
  //   url : config.urlAPI+'/publicar/infografia/' +id
  // },
  // {
  //   resourceName :"autorPublication",
  //   title : "Ver Infografia",
  //   field : "rec_id_infografia",
  //   url : config.urlSitelibros+'infografias/' +id
  // },  
  ]

  return(
    <EditInfografia
      resourceLabel = {resourceLabel}
      resourceName = {resourceName}
      id = {id}
      childrenForms = {childrenForms}
    ></EditInfografia>
  )
    
};
